module.exports = __webpack_public_path__ + "static/media/login-pic.5ee30b83.png";